import Vue from 'vue';
import SimpleVueValidation from 'simple-vue-validator';
const Validator = SimpleVueValidation.Validator;
const checkPassword = () => { // 숫자 영문만 가능하게 변경
    return helpers.regex('alphaNum', /^[A-Za-z0-9]*$/)
};

const checkString = () => { // 한글 + 부호는 - 만 입력가능
    return helpers.regex('alpha', /^[a-zA-Z가-힣ㄱ-ㅎㅏ-ㅣ\-]*$/)
};

const checkNumber = () => { // 숫자만 입력 가능
    return helpers.regex('alpha', /^[0-9]*$/);
};

Vue.use(SimpleVueValidation);
export default {
    data() {
        return{
            //어디민
            moc_idx : '',
            mo_reason : '',
            mb_name : '',
            mb_hp : '',
            mb_email : '',
            mb_memo : '',
            profile : [],
            UploadFlag : '',
            deleteProfile : [],
            //사용자
            mb_id: '',
            idOverlap: false,
            hasIdChk: false,
            mb_password : '',
            mb_password_chk : '',
            mb_nick: '',
            nickOverlap: false, //중복체크
            hasNickChk: false, //중복체크 여부 확인
            mb_birth: null,
            mb_age: '',
            mb_sex : 0,
            termAgree: false,
            mb_is_testor : 0,
            arSex : [
                {label: '남자',
                    value: 0},
                {label: '여자',
                    value: 1}
            ],
            arTester : [
                {label: '일반',
                    value: 0},
                {label: '테스터',
                    value: 1}
            ],
            //설문
            mb_body: 1, //체형
            // mb_shop_price: 1, //평균쇼핑금액
            mb_part:{outer:1,top:1,inner:1,pants:1,shoes:1,acc:1},// 각 파트별 쇼핑금액
            mb_color: [], //선호색상
            mb_face: 1, //얼굴형
            mb_skin: 1, //피부톤
            mb_job: 2, //직종
            mb_job_extra: '', //직종이 1인경우 입력값
            mb_mat_shoulder: 1, //착용감-어깨
            mb_mat_middle: 1, //착용감-배
            mb_mat_top: 1, //착용감-가슴 (남자만)
            mb_mat_bottom: 1, //착용감-힙 (남자만)
            mb_mat_waist: 1, //착용감-허리 (여자만)
            mb_mat_thigh: 1, //착용감-허벅지 (여자만)

            //정지
            stopReason: '',
            stopDateRange: [],
        }
    },
    validators: {

        moc_idx: function (value) {
            return Validator.value(value)
                .required('탈퇴사유를 입력해주세요.')
        },
        mo_reason: function (value) {
            return Validator.value(value)
                .required('탈퇴상세 사유를 입력해주세요.')
        },

        mb_email: function (value) {
            return Validator.value(value)
                .email('올바른 이메일 형식이 아닙니다.')
        },
        mb_id: function (value) {
            return Validator.value(value)
                .required('아이디를 입력해주세요.')
                .email('올바른 이메일 형식이 아닙니다.')
        },
        title: function (value) {
            return Validator.value(value)
                .required('제목을 입력해주세요.')
        },
        contents: function (value) {
            return Validator.value(value)
                .required('내용을 입력해주세요.')
        },
        mb_password: function (value) {
            return Validator.value(value)
                .required('비밀번호를 입력해주세요.')
                .minLength(8, '영문 대/소문자 포함 8자 이상으로 작성해주세요.')
                .regex('^.*(?=.*[0-9])(?=.*[a-zA-Z]).*$', '영문 대/소문자 포함 8자 이상으로 작성해주세요.')
        },
        mb_password_chk: function (value) {
            return Validator.value(value)
                .custom(
                    () => {
                        if(value != this.mb_password) {
                            return '비밀번호가 일치하지 않습니다.'
                        }
                    }
                )
        },
        mb_name: function (value) {
            return Validator.value(value)
                .required('이름을 입력해주세요.')
                .maxLength(5, '이름은 5자 이내만 가능합니다.')
                .regex('^[가-힣ㄱ-ㅎㅏ-ㅣ]*$', '이름은 한글만 가능합니다.')
        },
        mb_nick: function(value) {
            return Validator.value(value)
                .required('닉네임을 입력해주세요.')
                .maxLength(12, '닉네임은은 12자 이내만 가능합니다.')
                .regex('^[A-Za-z0-9\-\_]*$', '닉네임은 영문, 숫자, - 혹은 _으로 작성해주세요.')
        },
        mb_birth: function(value) {
            return Validator.value(value)
                .required('생년월일을 선택해주세요')
        },
        mb_age: function(value) {
            return Validator.value(value)
                .required('연령을 입력해주세요')
                .regex('^[0-9]*$', '숫자만 작성해주세요.')
        },
        mb_sex: function(value) {
            return Validator.value(value)
                .required('성별을 선택해주세요.')
                .greaterThanOrEqualTo(0, '성별을 선택해주세요.')
        },
        mb_body: function(value) {
            return Validator.value(value)
                .required('체형을 선택해주세요.')
                .greaterThanOrEqualTo(1, '체형을 선택해주세요.')
        },
        mb_part: function(value) {
            return Validator.value(value)
                .required('평균 쇼핑 금액을 선택해주세요.')
                // .greaterThanOrEqualTo(0, '평균 쇼핑 금액을 선택해주세요.')
                .custom(
                    () => {
                        if(value.outer === 0) {
                            return 'Outer의 쇼핑 금액을 선택해주세요.'
                        }
                        else if(value.top === 0) {
                            return 'Top의 쇼핑 금액을 선택해주세요.'
                        }
                        else if(value.inner === 0) {
                            return 'Inner의 쇼핑 금액을 선택해주세요.'
                        }
                        else if(value.pants === 0) {
                            return 'Pants의 쇼핑 금액을 선택해주세요.'
                        }
                        else if(value.shoes === 0) {
                            return 'Shoes의 쇼핑 금액을 선택해주세요.'
                        }
                        else if(value.acc === 0) {
                            return 'Acc의 쇼핑 금액을 선택해주세요.'
                        }
                    }
                )
        },
        mb_color: function(value) {
            return Validator.value(value)
                .required('선호하는 색상을 선택해주세요.')
                // .greaterThanOrEqualTo(1, '선호하는 색상을 선택해주세요.')
                .custom(
                    () => {
                        if(value.length === 0) {
                            return '선호하는 색상을 선택해주세요.'
                        }
                        else if(value.length >3){
                            return '색상은 세개까지 선택 가능합니다.'
                        }
                    }
                )
        },
        mb_face: function(value) {
            return Validator.value(value)
                .required('얼굴형을 선택해주세요.')
                .greaterThanOrEqualTo(1, '얼굴형을 선택해주세요.')
        },
        mb_skin: function(value) {
            return Validator.value(value)
                .required('피부톤을 선택해주세요.')
                .greaterThanOrEqualTo(1, '피부톤을 선택해주세요.')
        },
        mb_job: function(value) {
            return Validator.value(value)
                .required('직종을 선택해주세요.')
                .greaterThanOrEqualTo(1, '직종을 선택해주세요.')
        },
        mb_job_extra: function(value) {
            return Validator.value(value)
                .required('직종을 적어주세요.')
        },
        mb_mat_shoulder: function(value) {
            return Validator.value(value)
                .required('어깨에 대한 착용감을 선택해주세요.')
        },
        mb_mat_middle: function(value) {
            return Validator.value(value)
                .required('배에 대한 착용감을 선택해주세요.')
        },
        mb_mat_top: function(value) {
            return Validator.value(value)
                .required('가슴에 대한 착용감을 선택해주세요.')
        },
        mb_mat_bottom: function(value) {
            return Validator.value(value)
                .required('힙에 대한 착용감을 선택해주세요.')
        },
        mb_mat_waist: function(value) {
            return Validator.value(value)
                .required('허리에 대한 착용감을 선택해주세요.')
        },
        mb_mat_thigh: function(value) {
            return Validator.value(value)
                .required('허벅지에 대한 착용감을 선택해주세요.')
        },

        stopReason: function (value) {
            return Validator.value(value)
                .required('사유를 입력해주세요.')
        },
        stopDateRange: function (value) {
            return Validator.value(value)
                .required('기간을 선택해주세요.')
        }
    },
    methods:{
        CheckID() {
            this.$validate(['mb_id']).then(res => {
                if(res && !this.hasIdChk) {
                    let params = {
                        m_type: 'normal',
                        mb_id : this.mb_id,
                    }
                    this.$api.$auth.CheckId(params).then((res) => res.Data.Result).then(data => {
                        if(data.Info.Type === 1) {
                            this.hasIdChk = true;
                            this.idOverlap = false;
                        }else{
                            this.idOverlap = true;
                        }
                    })

                }
            })
        },
        resetChkId() {
            this.idOverlap = false;
            this.hasIdChk = false;
        },
        checkNick () {
            this.$validate(['mb_nick']).then(res => {
                if(res && !this.hasNickChk) {
                    let params = {
                        m_type: 'normal',
                        mb_nick : this.mb_nick,
                    }
                    this.$api.$auth.CheckNick(params).then(data => data.Data.Result).then(data => {
                        if(data.Info.Type === 1) {
                            this.hasNickChk = true;
                            this.nickOverlap = false;
                        }else{
                            this.nickOverlap = true;
                        }
                    })
                }
            });
        },
        resetChkNick() {
            this.nickOverlap = false;
            this.hasNickChk = false;
            // if(this.type === 'mypage') {
            //     // this.updateStroeData('hasNickChk', 'hasNickChk', this.hasNickChk, true)
            //     // this.updateStroeData('nickOverlap', 'nickOverlap', this.nickOverlap, true)
            //     this.$store.dispatch('common/setData', {data: this.hasNickChk, key: 'hasNickChk'});
            //     this.$store.dispatch('common/setData', {data: this.nickOverlap, key: 'nickOverlap'});
            // }
        },
    }
}
